import { render, staticRenderFns } from "./gameintro.vue?vue&type=template&id=4982d5ed&scoped=true"
import script from "./gameintro.vue?vue&type=script&lang=js"
export * from "./gameintro.vue?vue&type=script&lang=js"
import style0 from "./gameintro.vue?vue&type=style&index=0&id=4982d5ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4982d5ed",
  null
  
)

export default component.exports